module.exports = __webpack_public_path__ + "static/michael-bloomberg-5a058f648f8b45a6a3f30201f5afe7e4.jpg";